import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/legal/policy/pageContext';

export const PolicyErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Policy page (error: ${error})`);
};
